var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"submitShoppingCart",on:{"click":_vm.startBooking}},[_vm._v(_vm._s(_vm.buttonName))])
}
var staticRenderFns = []

export { render, staticRenderFns }